export const splitSupplierTin = (tin: string = '') => {
  // Remove any existing dashes just in case
  const cleaned = tin.replace(/-/g, '');

  const first = cleaned.slice(0, 3);
  const second = cleaned.slice(3, 6);
  const third = cleaned.slice(6, 9);

  const fourth = cleaned.slice(9, 14); 

  return [first, second, third, fourth];
};
